import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useState, useContext, useMemo, useRef } from 'react';
import ReactionBadge from './ReactionBadge.js';
import ReactionButton from './ReactionButton.js';
import ImageRenderer from './ImageRenderer.js';
import Icon, { IconTypes, IconColors } from './Icon.js';
import ContextMenu, { EmojiListItems } from './ContextMenu.js';
import { H as getEmojiUrl, I as isReactedBy, J as getEmojiTooltipString, G as getEmojiListAll, K as getEmojiMapAll, h as getClassName } from '../index-579ca9d7.js';
import BottomSheet from './BottomSheet.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../index-6420013c.js';
import UserListItem from './UserListItem.js';
import Tooltip from './Tooltip.js';
import TooltipWrapper from './TooltipWrapper.js';
import { u as useMediaQueryContext } from '../MediaQueryContext-d6110905.js';
import { u as useLongPress } from '../useLongPress-12280c78.js';
import { a as LocalizationContext } from '../LocalizationContext-a82461b5.js';
import useSendbirdStateContext from '../useSendbirdStateContext.js';
import { useMessageContext } from '../Message/context.js';
import { b as _extends } from '../_rollupPluginBabelHelpers-05128ded.js';
import '../utils-e0c7329c.js';
import 'prop-types';
import 'react-dom';
import './SortByRow.js';
import '../uuid-717930b4.js';
import '../utils/message/getOutgoingMessageState.js';
import '../stringSet-b60e9529.js';
import '../index-a9101009.js';
import '../UserProfileContext-f3f446d2.js';
import './Avatar.js';
import './MutedAvatarOverlay.js';
import './Checkbox.js';
import './UserProfile.js';
import '../sendbirdSelectors.js';
import '../topics-eb548880.js';
import './Button.js';
import '../index-6add7940.js';
import '../withSendbird.js';
var ReactedMembersBottomSheet = function ReactedMembersBottomSheet(_ref) {
  var _message$reactions, _message$reactions2, _message$reactions2$f;
  var message = _ref.message,
    channel = _ref.channel,
    _ref$emojiKey = _ref.emojiKey,
    emojiKey = _ref$emojiKey === void 0 ? '' : _ref$emojiKey,
    hideMenu = _ref.hideMenu,
    emojiContainer = _ref.emojiContainer;
  var _channel$members = channel.members,
    members = _channel$members === void 0 ? [] : _channel$members;
  var _useState = useState(emojiKey),
    _useState2 = _slicedToArray(_useState, 2),
    selectedEmoji = _useState2[0],
    setSelectedEmoji = _useState2[1];
  return /*#__PURE__*/React__default.createElement(BottomSheet, {
    onBackdropClick: hideMenu
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-message__bottomsheet"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-message__bottomsheet__reacted-members"
  }, (_message$reactions = message.reactions) === null || _message$reactions === void 0 ? void 0 : _message$reactions.map(function (reaction) {
    var emojiUrl = getEmojiUrl(emojiContainer, reaction.key);
    return /*#__PURE__*/React__default.createElement("div", {
      key: reaction.key,
      className: "\n                  sendbird-message__bottomsheet__reacted-members__item\n                  ".concat(selectedEmoji === reaction.key ? 'sendbird-message__bottomsheet__reacted-members__item__selected' : '', "\n                "),
      onClick: function onClick() {
        setSelectedEmoji(reaction.key);
      }
    }, /*#__PURE__*/React__default.createElement(ImageRenderer, {
      url: emojiUrl,
      width: "28px",
      height: "28px",
      placeHolder: function placeHolder(style) {
        return /*#__PURE__*/React__default.createElement("div", {
          style: style
        }, /*#__PURE__*/React__default.createElement(Icon, {
          type: IconTypes.QUESTION,
          fillColor: IconColors.ON_BACKGROUND_3,
          width: "28px",
          height: "28px"
        }));
      }
    }), /*#__PURE__*/React__default.createElement(Label, {
      type: LabelTypography.BUTTON_2,
      color: selectedEmoji === reaction.key ? LabelColors.PRIMARY : LabelColors.ONBACKGROUND_3
    }, reaction.userIds.length));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-message__bottomsheet__reactor-list"
  },
  // making a member list who reacted to the message with the `selectedEmoji`
  ((_message$reactions2 = message.reactions) === null || _message$reactions2 === void 0 ? void 0 : (_message$reactions2$f = _message$reactions2.find(function (reaction) {
    return reaction.key === selectedEmoji;
  })) === null || _message$reactions2$f === void 0 ? void 0 : _message$reactions2$f.userIds.map(function (userId) {
    return members.find(function (member) {
      return member.userId === userId;
    });
  }).filter(function (member) {
    return member !== undefined;
  })).map(function (member) {
    return /*#__PURE__*/React__default.createElement(UserListItem, {
      key: member.userId,
      className: "sendbird-message__bottomsheet__reactor-list__item",
      user: member,
      avatarSize: "36px"
    });
  }))));
};
function ReactionItem(_ref) {
  var _emojisMap$get;
  var reaction = _ref.reaction,
    memberNicknamesMap = _ref.memberNicknamesMap,
    setEmojiKey = _ref.setEmojiKey,
    toggleReaction = _ref.toggleReaction,
    emojisMap = _ref.emojisMap;
  var store = useSendbirdStateContext();
  var _useMediaQueryContext = useMediaQueryContext(),
    isMobile = _useMediaQueryContext.isMobile;
  var messageStore = useMessageContext();
  var message = messageStore === null || messageStore === void 0 ? void 0 : messageStore.message;
  var _useContext = useContext(LocalizationContext),
    stringSet = _useContext.stringSet;
  var userId = store.config.userId;
  var reactedByMe = isReactedBy(userId, reaction);
  var handleOnClick = function handleOnClick() {
    setEmojiKey('');
    toggleReaction === null || toggleReaction === void 0 ? void 0 : toggleReaction(message, reaction.key, reactedByMe);
  };
  var longPress = useLongPress({
    onLongPress: function onLongPress() {
      setEmojiKey(reaction.key);
    },
    onClick: handleOnClick
  }, {
    shouldPreventDefault: true,
    shouldStopPropagation: true
  });
  return /*#__PURE__*/React__default.createElement(TooltipWrapper, {
    className: "sendbird-emoji-reactions__reaction-badge",
    hoverTooltip: reaction.userIds.length > 0 ? /*#__PURE__*/React__default.createElement(Tooltip, null, getEmojiTooltipString(reaction, userId, memberNicknamesMap, stringSet)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null)
  }, /*#__PURE__*/React__default.createElement("div", isMobile ? longPress : {
    onClick: handleOnClick
  }, /*#__PURE__*/React__default.createElement(ReactionBadge, {
    count: reaction.userIds.length,
    selected: reactedByMe
  }, /*#__PURE__*/React__default.createElement(ImageRenderer, {
    circle: true,
    url: ((_emojisMap$get = emojisMap.get(reaction === null || reaction === void 0 ? void 0 : reaction.key)) === null || _emojisMap$get === void 0 ? void 0 : _emojisMap$get.url) || '',
    width: "20px",
    height: "20px",
    defaultComponent: /*#__PURE__*/React__default.createElement(Icon, {
      width: "20px",
      height: "20px",
      type: IconTypes.QUESTION
    })
  }))));
}
var AddReactionBadgeItem = function AddReactionBadgeItem(_ref) {
  var onClick = _ref.onClick;
  var onlyClick = useLongPress({
    onLongPress: function onLongPress() {/* noop */},
    onClick: onClick
  }, {
    shouldPreventDefault: true,
    shouldStopPropagation: true
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: "sendbird-emoji-reactions__add-reaction-badge"
  }, onlyClick), /*#__PURE__*/React__default.createElement(ReactionBadge, {
    isAdd: true
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: IconTypes.EMOJI_MORE,
    fillColor: IconColors.ON_BACKGROUND_3,
    width: "20px",
    height: "20px"
  })));
};
var MobileEmojisBottomSheet = function MobileEmojisBottomSheet(_ref) {
  var userId = _ref.userId,
    message = _ref.message,
    emojiContainer = _ref.emojiContainer,
    hideMenu = _ref.hideMenu,
    toggleReaction = _ref.toggleReaction;
  var emojiAllList = useMemo(function () {
    return getEmojiListAll(emojiContainer);
  }, [emojiContainer]);
  return /*#__PURE__*/React__default.createElement(BottomSheet, {
    onBackdropClick: hideMenu
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-message__bottomsheet sendbird-message__emojis-bottomsheet"
  }, emojiAllList.map(function (emoji) {
    var _message$reactions$fi, _message$reactions, _message$reactions$fi2, _message$reactions$fi3;
    var isReacted = (_message$reactions$fi = message === null || message === void 0 ? void 0 : (_message$reactions = message.reactions) === null || _message$reactions === void 0 ? void 0 : (_message$reactions$fi2 = _message$reactions.find(function (reaction) {
      return reaction.key === emoji.key;
    })) === null || _message$reactions$fi2 === void 0 ? void 0 : (_message$reactions$fi3 = _message$reactions$fi2.userIds) === null || _message$reactions$fi3 === void 0 ? void 0 : _message$reactions$fi3.some(function (reactorId) {
      return reactorId === userId;
    })) !== null && _message$reactions$fi !== void 0 ? _message$reactions$fi : false;
    return /*#__PURE__*/React__default.createElement(ReactionButton, {
      key: emoji.key,
      width: "44px",
      height: "44px",
      selected: isReacted,
      onClick: function onClick(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        toggleReaction === null || toggleReaction === void 0 ? void 0 : toggleReaction(message, emoji.key, isReacted);
        hideMenu();
      },
      dataSbId: "ui_mobile_emoji_reactions_menu_".concat(emoji.key)
    }, /*#__PURE__*/React__default.createElement(ImageRenderer, {
      url: emoji.url,
      width: "38px",
      height: "38px",
      placeHolder: function placeHolder(style) {
        return /*#__PURE__*/React__default.createElement("div", {
          style: style
        }, /*#__PURE__*/React__default.createElement(Icon, {
          type: IconTypes.QUESTION,
          fillColor: IconColors.ON_BACKGROUND_3,
          width: "28px",
          height: "28px"
        }));
      }
    }));
  })));
};
var EmojiReactions = function EmojiReactions(_ref) {
  var _message$reactions$le, _message$reactions, _message$reactions$le2, _message$reactions2, _message$reactions3;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    userId = _ref.userId,
    message = _ref.message,
    channel = _ref.channel,
    emojiContainer = _ref.emojiContainer,
    memberNicknamesMap = _ref.memberNicknamesMap,
    _ref$spaceFromTrigger = _ref.spaceFromTrigger,
    spaceFromTrigger = _ref$spaceFromTrigger === void 0 ? {
      x: 0,
      y: 0
    } : _ref$spaceFromTrigger,
    _ref$isByMe = _ref.isByMe,
    isByMe = _ref$isByMe === void 0 ? false : _ref$isByMe,
    toggleReaction = _ref.toggleReaction;
  var _useMediaQueryContext2 = useMediaQueryContext(),
    isMobile = _useMediaQueryContext2.isMobile;
  var addReactionRef = useRef(null);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showEmojiList = _useState4[0],
    setShowEmojiList = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedEmojiKey = _useState6[0],
    setSelectedEmojiKey = _useState6[1];
  var emojisMap = getEmojiMapAll(emojiContainer);
  var showAddReactionBadge = ((_message$reactions$le = (_message$reactions = message.reactions) === null || _message$reactions === void 0 ? void 0 : _message$reactions.length) !== null && _message$reactions$le !== void 0 ? _message$reactions$le : 0) < emojisMap.size;
  return /*#__PURE__*/React__default.createElement("div", {
    className: getClassName([className, 'sendbird-emoji-reactions', isByMe ? 'outgoing' : 'incoming'])
  }, ((_message$reactions$le2 = (_message$reactions2 = message.reactions) === null || _message$reactions2 === void 0 ? void 0 : _message$reactions2.length) !== null && _message$reactions$le2 !== void 0 ? _message$reactions$le2 : 0) > 0 && ((_message$reactions3 = message.reactions) === null || _message$reactions3 === void 0 ? void 0 : _message$reactions3.map(function (reaction) {
    return /*#__PURE__*/React__default.createElement(ReactionItem, {
      key: reaction === null || reaction === void 0 ? void 0 : reaction.key,
      reaction: reaction,
      memberNicknamesMap: memberNicknamesMap,
      setEmojiKey: setSelectedEmojiKey,
      toggleReaction: toggleReaction,
      emojisMap: emojisMap
    });
  })), !isMobile && showAddReactionBadge && /*#__PURE__*/React__default.createElement(ContextMenu, {
    menuTrigger: function menuTrigger(toggleDropdown) {
      return /*#__PURE__*/React__default.createElement(ReactionBadge, {
        className: "sendbird-emoji-reactions__add-reaction-badge",
        ref: addReactionRef,
        isAdd: true,
        onClick: function onClick(e) {
          var _e$stopPropagation;
          toggleDropdown();
          e === null || e === void 0 ? void 0 : (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 ? void 0 : _e$stopPropagation.call(e);
        }
      }, /*#__PURE__*/React__default.createElement(Icon, {
        type: IconTypes.EMOJI_MORE,
        fillColor: IconColors.ON_BACKGROUND_3,
        width: "20px",
        height: "20px"
      }));
    },
    menuItems: function menuItems(closeDropdown) {
      return /*#__PURE__*/React__default.createElement(EmojiListItems, {
        parentRef: addReactionRef,
        parentContainRef: addReactionRef,
        closeDropdown: closeDropdown,
        spaceFromTrigger: spaceFromTrigger
      }, getEmojiListAll(emojiContainer).map(function (emoji) {
        var _message$reactions4, _message$reactions4$f, _message$reactions4$f2;
        var isReacted = (message === null || message === void 0 ? void 0 : (_message$reactions4 = message.reactions) === null || _message$reactions4 === void 0 ? void 0 : (_message$reactions4$f = _message$reactions4.find(function (reaction) {
          return reaction.key === emoji.key;
        })) === null || _message$reactions4$f === void 0 ? void 0 : (_message$reactions4$f2 = _message$reactions4$f.userIds) === null || _message$reactions4$f2 === void 0 ? void 0 : _message$reactions4$f2.some(function (reactorId) {
          return reactorId === userId;
        })) || false;
        return /*#__PURE__*/React__default.createElement(ReactionButton, {
          key: emoji.key,
          width: "36px",
          height: "36px",
          selected: isReacted,
          onClick: function onClick(e) {
            closeDropdown();
            toggleReaction === null || toggleReaction === void 0 ? void 0 : toggleReaction(message, emoji.key, isReacted);
            e === null || e === void 0 ? void 0 : e.stopPropagation();
          },
          dataSbId: "ui_emoji_reactions_menu_".concat(emoji.key)
        }, /*#__PURE__*/React__default.createElement(ImageRenderer, {
          url: (emoji === null || emoji === void 0 ? void 0 : emoji.url) || '',
          width: "28px",
          height: "28px",
          placeHolder: function placeHolder(style) {
            return /*#__PURE__*/React__default.createElement("div", {
              style: style
            }, /*#__PURE__*/React__default.createElement(Icon, {
              type: IconTypes.QUESTION,
              fillColor: IconColors.ON_BACKGROUND_3,
              width: "28px",
              height: "28px"
            }));
          }
        }));
      }));
    }
  }), isMobile && showAddReactionBadge && /*#__PURE__*/React__default.createElement(AddReactionBadgeItem, {
    onClick: function onClick() {
      setShowEmojiList(true);
    }
  }), isMobile && showEmojiList && /*#__PURE__*/React__default.createElement(MobileEmojisBottomSheet, {
    userId: userId,
    message: message,
    emojiContainer: emojiContainer,
    hideMenu: function hideMenu() {
      setShowEmojiList(false);
    },
    toggleReaction: toggleReaction
  }), isMobile && selectedEmojiKey && channel !== null && /*#__PURE__*/React__default.createElement(ReactedMembersBottomSheet, {
    message: message,
    channel: channel,
    emojiKey: selectedEmojiKey,
    hideMenu: function hideMenu() {
      setSelectedEmojiKey('');
    },
    emojiContainer: emojiContainer
  }));
};
export { EmojiReactions as default };